import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { ImageEntity } from "../../../../../shared/entities/file/image.entity";
import { PostFileMediaType } from "../../../../../shared/enums/campaignPost.enums";
import { CarouselEditItemElementDirective } from "./carousel-edit-item.directive";

@Component({
  selector: "app-carousel-edit",
  exportAs: "app-carousel-edit",
  templateUrl: "./carousel-edit.component.html",
  styleUrl: "./carousel-edit.component.scss",
})
export class CarouselEditComponent implements OnInit {
  @Input({ required: true }) public slides!: ImageEntity[];
  @Input() public showTitles = true;
  @Input() public showDescriptions = true;
  @Input() public showAltTexts = false;

  @Output() public deleteItem = new EventEmitter<ImageEntity>();

  @ViewChildren(CarouselEditItemElementDirective, { read: ElementRef })
  private itemsElements!: QueryList<ElementRef>;
  @ViewChild("carousel")
  private carousel!: ElementRef<HTMLDivElement>;
  @ViewChild("carouselWrapper")
  private carouselWrapper!: ElementRef<HTMLElement>;

  protected readonly PostFileMediaType = PostFileMediaType;
  protected carrouselOffset = 0;
  protected currentSlide = 0;
  protected isFooterShown = false;

  constructor(private readonly domSanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    this.isFooterShown =
      this.showAltTexts || this.showDescriptions || this.showTitles;
  }

  protected next(): void {
    const nextSlide = (this.currentSlide + 1) % this.slides.length;
    this.moveToSlide(nextSlide);
  }

  protected prev(): void {
    const prevSlide =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.moveToSlide(prevSlide);
  }

  public moveToSlide(slideIndex: number): void {
    this.currentSlide = slideIndex;
    this.animate();
  }

  public goToEnd(): void {
    this.moveToSlide(this.slides.length - 1);
  }

  public moveBackFromLastSlide(
    slides: ImageEntity[],
    removedIndex: number,
  ): void {
    if (removedIndex === slides.length) {
      this.prev();
    }
  }

  private animate(): void {
    const itemWidth =
      this.itemsElements.first.nativeElement.getBoundingClientRect().width;

    const wrapperWidth =
      this.carouselWrapper.nativeElement.getBoundingClientRect().width;

    const offset =
      this.currentSlide === 0
        ? 0
        : (itemWidth + 8) * this.currentSlide - (wrapperWidth - itemWidth) / 2;

    this.carousel.nativeElement.parentElement!.scrollLeft = 0;
    this.carrouselOffset = -offset;
  }

  protected onDeleteItem(item: ImageEntity): void {
    this.deleteItem.emit(item);
  }

  protected getSanitizedUrl(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }
}
